var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-empty',{attrs:{"image":_vm.icon,"image-size":400,"description":"页面出差了..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }